import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid-pro';
import { formatTranslation } from 'intl';
import { FiltersTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { IssueState } from '../../types';
import { issueStateValueGetter } from '../../valueGetters';
import { createRowValueEqualsFilterPredicate } from '../common';
import { IssueStateFilterInput } from '../issueStateFilter';

export const getIssueStateOperator = (
  intl: IntlShape
): GridFilterOperator => {
  const isIssueStateFilterValue = (
    value: GridFilterItem['value']
  ): value is IssueState => {
    return value === IssueState.published || value === IssueState.archived;
  };

  return {
    label: formatTranslation(intl, FiltersTranslationKeys.operatorIs),
    value: 'is',
    getApplyFilterFn: (filterItem: GridFilterItem) =>
      createRowValueEqualsFilterPredicate<
        { deleted?: boolean },
        IssueState,
        IssueState | null
      >(
        filterItem,
        (row) => issueStateValueGetter(null, row),
        isIssueStateFilterValue
      ),
    InputComponent: IssueStateFilterInput,
  };
};
